import React from "react";

export default function Templates() {
  return (
    <>
      <p><strong>Parágrafo</strong> - Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado desde o século XVI, quando um impressor desconhecido pegou uma bandeja de tipos e os embaralhou para fazer um livro de modelos de tipos. Lorem Ipsum sobreviveu não só a cinco séculos.</p>
      <h1>h1 - Cromo Construtora</h1>
      <h1>0123456789</h1>
      <h2>h2 - Cromo Construtora</h2>
      <h2>0123456789</h2>
      <h3>h2 - Cromo Construtora</h3>
      <h3>0123456789</h3>
      <h4>h4 - Cromo Construtora</h4>
      <h4>0123456789</h4>
      <h5>h5 - Cromo Construtora</h5>
      <h5>0123456789</h5>
      <h6>h6 - Cromo Construtora</h6>
      <h6>0123456789</h6>
    </>
  );
}
